import { Injectable } from "@angular/core";
import { METRIC, PaymentMetricProperties } from "@backend/common/analytics/metrics";
import { AnalyticsService } from "@apps/patient-core/src/app/services/analytics.service";
import { CacheService } from "@apps/patient-core/src/app/services/cache.service";
import { PersistentObjectFactory } from "@apps/patient-core/src/app/utils/persistent-object";
import { BaseAuthService } from "@apps/patient-core/src/app/services/abstracts/auth.service";
import { logger } from "@dentally/ui/logger";

@Injectable({
  providedIn: "root",
})
export class PaymentsMetricsService {
  private _properties: PaymentMetricProperties;
  private _persistentObjectFactory: PersistentObjectFactory<PaymentMetricProperties>;

  constructor(public _authService: BaseAuthService, private _analyticsService: AnalyticsService, cacheService: CacheService) {
    this._persistentObjectFactory = new PersistentObjectFactory(cacheService, "payment-metric-properties");
    this._properties = this._persistentObjectFactory.create(new PaymentMetricProperties());
  }

  public trackPaymentDue(amount: number): void {
    try {
      this._properties.referrer = this._authService.getJWT().referrer;
      this._properties.amount = amount;
      this._analyticsService.track(new METRIC.ActionDue_Payment(this._properties.referrer, this._properties.amount));
    } catch (e) {
      logger.error("error tracking payment due metric", e);
    }
  }

  public trackPaymentOpened(amount: number): void {
    try {
      this._properties.referrer = this._authService.getJWT().referrer;
      this._properties.amount = amount;
      this._analyticsService.track(new METRIC.ActionOpened_Payment(this._properties.referrer, this._properties.amount));
    } catch (e) {
      logger.error("error tracking payment opened metric", e);
    }
  }

  public trackPaymentDone(siteId: string, paymentMethod?: string | undefined): void {
    try {
      this._properties.referrer = this._authService.getJWT().referrer;
      this._properties.payment_method = paymentMethod;
      this._analyticsService.track(new METRIC.ActionDone_Payment(siteId, this._properties.referrer, this._properties.amount, this._properties.payment_method));
      this._persistentObjectFactory.clear(this._properties);
    } catch (e) {
      logger.error("error tracking payment done metric", e);
    }
  }
}
